import { useNavigate } from "react-router-dom";
import styles from "./mainMenuIconList.module.scss";

/**
 * 메인 메뉴 아이콘 목록 컴포넌트
 * @param {array} icons - 아이콘 배열
 * @param {string} icons[].id - 아이콘 고유 ID
 * @param {string} icons[].name - 아이콘 이름 (aria-label용)
 * @param {string} icons[].icon - 아이콘 이미지 경로
 * @param {string} icons[].path - 클릭 시 이동할 경로 (선택)
 * @param {boolean} icons[].hasNotification - 알림 표시 여부 (선택)
 * @param {function} icons[].onClick - 클릭 핸들러 함수 (선택, path보다 우선)
 * @returns
 */
const MainMenuIconList = ({ icons = [] }) => {
    const navigate = useNavigate();

    const handleIconClick = (icon) => {
        if (icon.onClick) {
            icon.onClick();
            return;
        }
        if (icon.path) {
            navigate(icon.path);
        }
    };

    const handleKeyDown = (e, icon) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleIconClick(icon);
        }
    };

    if (!icons || icons.length === 0) {
        return null;
    }

    return (
        <div className={styles["main-menu-icon-list"]}>
            {icons.map((icon) => (
                <button
                    key={icon.id}
                    className={styles["icon-button"]}
                    onClick={() => handleIconClick(icon)}
                    onKeyDown={(e) => handleKeyDown(e, icon)}
                    aria-label={icon.name || "아이콘 버튼"}
                    tabIndex="0"
                >
                    <img
                        src={icon.icon}
                        alt={icon.name || "아이콘"}
                        className={styles["icon-image"]}
                    />
                    {icon.hasNotification && (
                        <span
                            // className={styles["notification-dot"]}
                            aria-label="새 소식"
                        />
                    )}
                </button>
            ))}
        </div>
    );
};

export default MainMenuIconList;
